"use strict";
var core_1 = require('@angular/core');
var common_1 = require('@angular/common');
var Octave = (function () {
    function Octave() {
        this.blackKeyOffsetMap = {
            1: 1,
            3: 2,
            6: 4,
            8: 5,
            10: 6,
        };
        this.whiteKeys = [0, 2, 4, 5, 7, 9, 11];
        this.blackKeys = [1, 3, 6, 8, 10];
    }
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Function)
    ], Octave.prototype, "handlePress", void 0);
    Octave = __decorate([
        core_1.Component({
            selector: 'octave',
            template: "\n    <div style=\"height:100%;width:100%;background:#FFF;position:relative;\">\n      <table style=\"height:100%;width:100%;text-align:center;\n        table-layout:fixed;\">\n        <tbody>\n          <tr>\n            <td *ngFor=\"let key of whiteKeys; let i = index\"\n              style=\"border:1px solid #000;color:#333;\"\n              (click)=\"handlePress(key)\">\n            </td>\n          </tr>\n        </tbody>\n      </table>\n      <div *ngFor=\"let key of blackKeys; let i = index\"\n           [ngStyle]=\"{left: blackKeyOffsetMap[key] * 100/7 + '%'}\"\n           style=\"position:absolute;top:0;color:#FFF;width:10px;\n           margin-left:-5px;height:70%;background:#000;\"\n           (click)=\"handlePress(key)\">\n      </div>\n    </div>\n  ",
            directives: [common_1.NgStyle],
            changeDetection: core_1.ChangeDetectionStrategy.OnPush,
        }), 
        __metadata('design:paramtypes', [])
    ], Octave);
    return Octave;
}());
exports.Octave = Octave;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib2N0YXZlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsib2N0YXZlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxxQkFJTyxlQUFlLENBQUMsQ0FBQTtBQUV2Qix1QkFFTyxpQkFBaUIsQ0FBQyxDQUFBO0FBNkJ6QjtJQWNFO1FBWFEsc0JBQWlCLEdBQUc7WUFDMUIsQ0FBQyxFQUFFLENBQUM7WUFDSixDQUFDLEVBQUUsQ0FBQztZQUNKLENBQUMsRUFBRSxDQUFDO1lBQ0osQ0FBQyxFQUFFLENBQUM7WUFDSixFQUFFLEVBQUUsQ0FBQztTQUNOLENBQUM7UUFFTSxjQUFTLEdBQWtCLENBQUMsQ0FBQyxFQUFFLENBQUMsRUFBRSxDQUFDLEVBQUUsQ0FBQyxFQUFFLENBQUMsRUFBRSxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUM7UUFDbEQsY0FBUyxHQUFrQixDQUFDLENBQUMsRUFBRSxDQUFDLEVBQUUsQ0FBQyxFQUFFLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUdwRCxDQUFDO0lBZEQ7UUFBQyxZQUFLLEVBQUU7OytDQUFBO0lBNUJWO1FBQUMsZ0JBQVMsQ0FBQztZQUNULFFBQVEsRUFBRSxRQUFRO1lBQ2xCLFFBQVEsRUFBRSx3d0JBb0JUO1lBQ0QsVUFBVSxFQUFFLENBQUMsZ0JBQU8sQ0FBQztZQUNyQixlQUFlLEVBQUUsOEJBQXVCLENBQUMsTUFBTTtTQUNoRCxDQUFDOztjQUFBO0lBa0JGLGFBQUM7QUFBRCxDQUFDLEFBaEJELElBZ0JDO0FBaEJZLGNBQU0sU0FnQmxCLENBQUE7QUFBQSxDQUFDIn0=


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/sequencer/keyboard/octave.ts
 ** module id = 427
 ** module chunks = 1
 **/